import AirportUIModel from './airport';
import regexMap from '../../scripts/constants/regex-map';
import latinCharacters from '../../scripts/constants/latin-characters';

class AirportsMapUIModel {
  constructor(airports = {}) {
    this._airports = {};
    this._airportsList = [];

    for (const airportCode in airports) {
      if ( airports.hasOwnProperty(airportCode) ) {
        const airport = new AirportUIModel(airports[airportCode]);
        this._airports[airportCode] = airport;

        this._airportsList.push(airport);
      }
    }
    this.sortAirportsByCity = this.sortAirportsByCity.bind(this);
  }

  getAllAirports() {
    return this._airportsList;
  }

  getAirportByCode(airportCode) {
    return this._airports[airportCode];
  }

  getAirportCityByCode(airportCode) {
    if (!this.getAirportByCode(airportCode)) {
      console.warn(`Tried to get city from missing airport: ${airportCode}`); // eslint-disable-line no-console
      return airportCode;
    }

    return this.getAirportByCode(airportCode).city;
  }

  getAirportNameByCode(airportCode) {
    if (!this.getAirportByCode(airportCode)) {
      console.warn(`Tried to get city from missing airport: ${airportCode}`); // eslint-disable-line no-console
      return airportCode;
    }

    return this.getAirportByCode(airportCode).airportName;
  }

  isTransborderByCode(airportCode) {
    if (!this.getAirportByCode(airportCode)) {
      console.warn(`Tried to get city from missing airport: ${airportCode}`); // eslint-disable-line no-console
      return airportCode;
    }

    return this.getAirportByCode(airportCode).region === 'USA & Canada';
  }

  getDestinationAirportsByCode(airportCode) {
    const airport = this._airports[airportCode];
    const destinationAirportList = [];

    if ( airport ) {
      if ( typeof(airport.fliesTo) !== 'string' ) {
        airport.fliesTo.forEach((airportCode) => {
          const destinationAirport = this._airports[airportCode];

          if (destinationAirport) destinationAirportList.push(destinationAirport);
          else console.warn(`An airport is missing in the API response: ${airportCode}`); // eslint-disable-line no-console
        });
      }
    }

    return destinationAirportList;
  }

  /**
   * Return airports by their global region
   * @param  {Array} airportList - array of AirportUiModel
   * @return {Object}
   */
  getAirportsByRegion(airportList) {
    return airportList
      .filter(airport => airport.region)
      .reduce(function(airportRegions, airport) {
        if (!airportRegions[airport.region]) {
          airportRegions[airport.region] = [];
        }
        airportRegions[airport.region].push(airport);
        return airportRegions;
      }, {});
  }

  /**
   * Return airports by their country
   * @param  {Array} airportList - array of AirportUiModel
   * @return {Object}
   */
  getAirportsByCountry(airportList, country) {
    return airportList.filter(airport => airport.country === country);
  }

  getNormalizedCityName(cityName) {
    let normalizedCityName = cityName;

    if (regexMap.NON_ALPHA_LATIN_CHARACTERS.test(cityName)) {
      normalizedCityName = normalizedCityName.replace(regexMap.NON_ALPHA_LATIN_CHARACTERS, (match) => {
        return latinCharacters[match];
      });
    }

    return normalizedCityName;
  }

  sortAirportsByCity() {
    this._airportsList.sort((a, b) => {
      const normalizedCityA = this.getNormalizedCityName(a.city);
      const normalizedCityB = this.getNormalizedCityName(b.city);

      if (normalizedCityA < normalizedCityB) {
        return -1;
      } else if (normalizedCityA > normalizedCityB) {
        return 1;
      }

      return 0;
    });
  }
}


export default AirportsMapUIModel;
